<template>
  <!-- <div class="client"> -->
  <div>
    <v-alert
      :value="alert"
      class="bold h4 alert"
      color="orange"
      icon="new_releases"
      transition="scale-transition"
    >
      Upozornění! Nacházíte se v zobrazení pro úpravy klienta.
    </v-alert>
    <header :class="{'active': mobileMenu, 'alert-active': alert}">
      <v-container>
        <v-layout row wrap align-center justify-space-between v-if="!loading">
          <eshop-link :to="{ path: '/klientska-zona/'+klient }">
            <v-layout row wrap align-center>
              <img src="@/assets/images/logo-cc-tu.png" alt="Logo" class="logo client-logo-desktop">
              <div class="client-logo-mobile button py-1 px-3 mr-3"><v-icon color="white">home</v-icon></div>
              <h1 class="h3"><span v-if="!$vuetify.breakpoint.smAndDown" style="color: black!important">Klientská zóna - </span>{{klientInfo.nazev_osoby}}</h1>
            </v-layout>
          </eshop-link>
          <div class="actual-price">
            <p><strong>Aktuální cena</strong></p>
            <p class="inline-block">
              <strong>Zlato 1 oz: <span class="text-primary" v-if="cena_zlato!=null">{{cena_zlato | formatMoney}} Kč</span><span v-else>--</span></strong>
            </p>
            <p class="inline-block ml-3">
              <strong>Stříbro 1 kg: <span class="text-primary" v-if="cena_stribro!=null">{{cena_stribro | formatMoney}} Kč</span><span v-else>--</span></strong>
            </p>
          </div>
          <eshop-link  :to="{ path : '/klienti' }">
            <v-btn dark class="elevation-0 button button-signout button-client__close px-5 ma-0">Zpět</v-btn>
          </eshop-link>
          <v-btn dark class="elevation-0 button button-mobile ma-0" @click="mobileMenu=true">Menu</v-btn>
          <nav role="navigation" class="mobile-menu">
            <ul @click="mobileMenu=false">
              <li class="main">
                  <eshop-link :to="{ path: '/klientska-zona/' + klient + '/ucet-klienta' }" class="h3">Údaje o klientovi</eshop-link>
              </li>
              <li class="main">
                <eshop-link :to="{ path: '/klientska-zona/' + klient + '/zbozi' }" class="h3">Zboží klienta</eshop-link>
              </li>
              <li class="main">
                <eshop-link :to="{ path: '/klientska-zona/' + klient + '/faktury' }" class="h3">Faktury klienta</eshop-link>
              </li>
              <li class="main">
                <eshop-link :to="{ path: '/klientska-zona/' + klient + '/penezenka' }" class="h3">Peněženka</eshop-link>
              </li>
            </ul>
            <p class="mb-0 text-xs-center">
              <div class="text-xs-center"><v-btn dark color="grey" class="elevation-0 bold mx-0 mt-5 mb-3" @click="mobileMenu=false">Zavřít menu</v-btn></div>
              <div class="text-xs-center">
                <eshop-link  :to="{ path : '/klienti' }">
                  <v-btn dark color="grey lighten-1" class="elevation-0 bold ma-0 px-5">Zpět</v-btn>
                </eshop-link>
              </div>
              <div class="text-xs-center">
                <v-btn dark class="elevation-0 button button-signout button-mobile-show ma-0 mt-3 mb-4" @click="signout">Odhlásit</v-btn>
              </div>
            </p>
          </nav>
        </v-layout>
        <v-layout row wrap v-if="!loading">
          <v-flex xs12>
            <ul class="navigation" :class="{'alert-menu__active': alert}">
              <li>
                <eshop-link :to="{ path: '/klientska-zona/' + klient + '/' }" class="button button-home"><v-icon color="white">home</v-icon></eshop-link>
              </li>
              <li>
                <eshop-link :to="{ path: '/klientska-zona/' + klient + '/ucet-klienta' }">Údaje o klientovi</eshop-link>
              </li>
              <li>
                <eshop-link :to="{ path: '/klientska-zona/' + klient + '/zbozi' }">Zboží klienta</eshop-link>
              </li>
              <li>
                <eshop-link :to="{ path: '/klientska-zona/' + klient + '/faktury' }">Faktury klienta</eshop-link>
              </li>
              <li>
                <eshop-link :to="{ path: '/klientska-zona/' + klient + '/penezenka' }">Peněženka</eshop-link>
              </li>
            </ul>
          </v-flex>
        </v-layout>
      </v-container>
    </header>
    <router-view/>
  </div>

</template>

<script>

import Login from '@/components/Login'

export default {
  name: 'Client',
  data () {
    return {
      bottomNav: 'eshop',
      mobileMenu: false,
      isSigned: false,
      loading: true,
      kosik: null,
      alert: true,
      klientInfo: {},
      cena_zlato: null,
      cena_stribro: null,
      interval: null
    };
  },
  computed: {
    me: function() {
      return window.$me;
    }
  },
  props: {
    klient: String
  },
  watch: {
    $route (to, from){
      window.API.get("nastenka/komodity").then(function(body) {
        this.cena_zlato = body.zlato;
        this.cena_stribro = body.stribro;
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    }
  },
  mounted () {
    this.interval = setInterval(() => {
      window.API.get("nastenka/komodity").then(function(body) {
        this.cena_zlato = body.zlato;
        this.cena_stribro = body.stribro;
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    }, 120000);
    window.API.get("klient/info/" + this.klient).then(function(body) {
      this.klientInfo = body;
      this.loading = false;
    }.bind(this)).catch(function(err) {
    }.bind(this));
    window.API.get("nastenka/komodity").then(function(body) {
      this.cena_zlato = body.zlato;
      this.cena_stribro = body.stribro;
    }.bind(this)).catch(function(err) {
      console.log(err);
    }.bind(this));
  },
  beforeDestroy () {
    clearInterval(this.interval);
  },
  methods: {
    signout: function() {
      window.API.$setCookie("cc_eshop_uid", "", { expires: -30, path: "/" });
      window.API.$setCookie("cc_eshop_token", "", { expires: -30, path: "/" });
      window.location.reload();
    }
  },
  components: {
    Login
  }
}
</script>
